import { useCallback } from 'react';

import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { useGameDispatch } from '../../store/GameStore';
import { fetchChartsDataAction } from '../apiActions/fetchChartsDataAction';

export const useChartsDataFetcher = (force: boolean = false): (() => void) => {
  const dispatch = useGameDispatch();
  const recentResultsCount = 500;
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const tableId = useConfigSlice.tableId();
  const metaServerAddress = useConfigSlice.getMetaServer();

  return useCallback(() => {
    if (recentResultsCount && JSESSIONID && metaServerAddress && tableId) {
      dispatch(
        fetchChartsDataAction({
          JSESSIONID,
          tableId,
          numberOfGames: recentResultsCount,
          url: `${metaServerAddress}/api/ui/crash/multipliers/percentage`,
          force: force,
        })
      );
    }
  }, [dispatch, recentResultsCount, JSESSIONID, metaServerAddress, tableId]);
};
